var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinOriginal = function SvgLinkedinOriginal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2767B2",
    fillRule: "nonzero",
    d: "M22.958 0H6.042A6.04 6.04 0 0 0 0 6.042v16.916A6.04 6.04 0 0 0 6.042 29h16.916A6.04 6.04 0 0 0 29 22.958V6.042A6.04 6.04 0 0 0 22.958 0M9.667 22.958H6.042V9.667h3.625zM7.854 8.135A2.124 2.124 0 0 1 5.74 6.002c0-1.177.947-2.131 2.114-2.131s2.115.954 2.115 2.131a2.123 2.123 0 0 1-2.115 2.131m16.313 14.823h-3.625v-6.771c0-4.07-4.834-3.762-4.834 0v6.771h-3.625V9.667h3.625v2.132c1.687-3.124 8.459-3.355 8.459 2.992z"
  })));
};
export default SvgLinkedinOriginal;